import React from "react";
import { connect } from "react-redux";
import { get, map, size, includes, filter, concat } from "lodash";

import { expandItem, initiateExpandSection } from "../../actions/companies";

import Grid from "@material-ui/core/Grid";

import ScrollableTable from "../Common/Table/ScrollableTable";
import CreateContainer from "./CreateContainer";
import CompaniesTableRow from "./CompaniesTableRow";

import { levels } from "../../constants/companies";

import {
  getQueryStringValue,
  setQueryStringValue,
} from "../../utils/queryString";

const CompanySites = (props) => {
  const {
    dispatch,
    powerUserMode,
    item,
    companyId,
    siteId,
    zoneId,
    deviceId,
    level,
    getNextLevel,
    fetchItem,
    fetchZones,
    fetchDevices,
    isFetching,
  } = props;

  const storeKey = zoneId || siteId || companyId;

  const { expandedSites, expandedZones } = get(props, [
    "companies",
    storeKey,
  ]) || { expandedSites: [], expandedZones: [] };

  React.useEffect(() => {
    let newSites, newZones;
    if (size(expandedSites) > 0) {
      setQueryStringValue("expandedSites", expandedSites);
    } else {
      newSites = getQueryStringValue("expandedSites");
    }
    if (size(expandedZones) > 0) {
      setQueryStringValue("expandedZones", expandedZones);
    } else {
      newZones = getQueryStringValue("expandedZones");
    }

    if (!get(props, ["companies", storeKey])) {
      dispatch(initiateExpandSection(storeKey, null, newSites, newZones));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (level === levels.site && get(item, ["id"])) {
      fetchZones(companyId, siteId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(item)]);

  const onExpand = (expandedLevel, newId) => {
    // Dispatch action
    dispatch(expandItem(storeKey, expandedLevel, newId));

    // Update URL
    if (includes(get(props, ["companies", storeKey, expandedLevel]), newId)) {
      setQueryStringValue(
        expandedLevel,
        filter(
          get(props, ["companies", storeKey, expandedLevel]),
          (i) => i !== newId
        )
      );
    } else {
      setQueryStringValue(
        expandedLevel,
        concat(get(props, ["companies", storeKey, expandedLevel]), [newId])
      );
    }
  };

  let columns = [];
  if ([levels.company].includes(level)) {
    columns.push({
      name: "profiles_sites",
      minWidth: 200,
    });
  }
  if ([levels.company, levels.site].includes(level)) {
    columns.push({
      name: "companies_zones",
      minWidth: 200,
    });
  }
  columns.push(
    {
      name: "companies_assignedProfiles",
      minWidth: 200,
    },
    {
      name: "companies_devices",
      minWidth: 200,
    }
  );

  let zoneDetailed = false;
  if (
    level === levels.site ||
    (level === levels.zone && getNextLevel(level) === levels.childZone)
  ) {
    zoneDetailed = true;
    columns = [
      {
        name: "companies_zones",
        minWidth: 200,
      },
      {
        name: "companies_devices",
        minWidth: 100,
      },
      {
        name: "companies_assignedProfiles",
        minWidth: 100,
      },
      {
        name: "profiles_type",
        minWidth: 150,
      },
      {
        name: "common_color",
        minWidth: 70,
      },
      {
        name: "dashboard_entrance",
        minWidth: 100,
      },
      {
        name: "dashboard_exit",
        minWidth: 100,
      },
      {
        name: "profiles_comments",
        minWidth: 270,
      },
      // {
      //   name: "profiles_description",
      //   minWidth: 200,
      // },
    ];
    if (powerUserMode) {
      columns.push({
        name: "site_siteImpactCount",
        minWidth: 100,
        width: 100,
      });
      columns.push({
        name: "site_vehicleAccess",
        minWidth: 100,
        width: 100,
      });
      columns.push({
        name: "site_humanAccess",
        minWidth: 100,
        width: 100,
      });
    }
  }

  if (level === levels.zone && getNextLevel(level) !== levels.childZone) {
    columns = [
      {
        name: "companies_devices",
        minWidth: 200,
      },
      {
        name: "profiles_type",
        minWidth: 150,
      },
    ];
  }

  return (
    <>
      <Grid item style={{ marginBottom: "24px" }}>
        <CreateContainer
          dialog={true}
          refresh={fetchItem}
          level={
            getNextLevel(level) === levels.childZone
              ? levels.zone
              : getNextLevel(level)
          }
          item={item}
          companyId={companyId}
          siteId={siteId}
          zoneId={zoneId}
          deviceId={deviceId}
          subZone={getNextLevel(level) === levels.childZone}
        />
      </Grid>
      <Grid
        item
        style={{
          overflow: "auto",
          maxWidth:
            includes([levels.zone, levels.childZone], level) &&
            getNextLevel(level) !== levels.childZone
              ? "500px"
              : "",
        }}
      >
        <ScrollableTable
          columns={columns}
          hasMore={false}
          isFetching={isFetching}
          stickyHeader
        >
          {map(get(item, [`${getNextLevel(level)}s`]), (item, index) => (
            <CompaniesTableRow
              key={get(item, ["id"])}
              index={index}
              item={{
                ...item,
                company_id: companyId,
                site_id: siteId,
                zone_id: zoneId,
                device_id: deviceId,
              }}
              fetchZones={fetchZones}
              fetchDevices={fetchDevices}
              level={getNextLevel(level)}
              levelId={0}
              language={props.language}
              isLast={
                index === size(get(item, [`${getNextLevel(level)}s`])) - 1
              }
              hide={{
                company: true,
                site: [levels.site, levels.zone, level.device].includes(level),
                zone: [levels.zone, level.device].includes(level),
              }}
              zoneDetailed={zoneDetailed}
              powerUserMode={powerUserMode}
              expandedSites={expandedSites}
              expandedZones={expandedZones}
              onExpand={onExpand}
            />
          ))}
        </ScrollableTable>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    powerUserMode: get(state, ["common", "powerUserModeEnabled"]),
    companies: get(state, ["companies"]),
  };
};

export default connect(mapStateToProps)(CompanySites);
